var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0043 3C16.1089 3 17.0043 3.89543 17.0043 5V11.1333C17.0728 12.1758 17.9401 13.0002 18.9999 13.0002H20.4612V13.0043H25.0084C26.113 13.0043 27.0084 13.8997 27.0084 15.0043C27.0084 16.1089 26.113 17.0043 25.0084 17.0043H18.8706C17.8703 17.0681 17.07 17.8673 17.0043 18.8671V25.0084C17.0043 26.113 16.1089 27.0084 15.0043 27.0084C13.8997 27.0084 13.0043 26.113 13.0043 25.0084V20.4607H12.9999V19.0002C12.9999 17.939 12.1735 17.0709 11.1292 17.0043H5C3.89543 17.0043 3 16.1089 3 15.0043C3 13.8997 3.89543 13.0043 5 13.0043H9.54753V13.0002H10.9999C12.1045 13.0002 12.9999 12.1047 12.9999 11.0002V9.54705H13.0043V5C13.0043 3.89543 13.8997 3 15.0043 3Z",
    fill: "#0071FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.fe0556991ab950866913ad2137d06ba3.svg";
export { ForwardRef as ReactComponent };